// extracted by mini-css-extract-plugin
export var backbutton = "FormBuilder-module--backbutton--68a18";
export var beigebg = "FormBuilder-module--beigebg--28e6e";
export var buttonwrapper = "FormBuilder-module--buttonwrapper--cc968";
export var conditionalbackground = "FormBuilder-module--conditionalbackground--ae627";
export var errorMessage = "FormBuilder-module--errorMessage--021e1";
export var fieldSpacing = "FormBuilder-module--fieldSpacing--f4be9";
export var form = "FormBuilder-module--form--1fb43";
export var labelWrapper = "FormBuilder-module--labelWrapper--5d195";
export var modaltitle = "FormBuilder-module--modaltitle--e44af";
export var nextbutton = "FormBuilder-module--nextbutton--21dbc";
export var required = "FormBuilder-module--required--00649";
export var submissionblockedwarningmodal = "FormBuilder-module--submissionblockedwarningmodal--0bea7";
export var submissionblockedwarningmodalcta = "FormBuilder-module--submissionblockedwarningmodalcta--2f25d";
export var whitebg = "FormBuilder-module--whitebg--38806";